import React, { useState, useEffect, useMemo } from "react";
import {
    Button, FormControl, InputLabel, MenuItem, Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Divider,
    IconButton,
} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import { formatDate } from "../../utils/dateFormat";
import SchoolDatePicker from "../../components/SchoolDatePicker/SchoolDatePicker";
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import StudentService from "./Locality/Service/studentService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import * as Yup from 'yup';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDomainFeatures } from "../../context/DomainFeaturesContext";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function StudentForm(props, history) {
    const { id } = useParams();
    const location = useLocation();
    const routerHistory = useHistory();
    const { useStudentIdLabel, useEnrollmentDateLabel, hideAadhaarNumber, hideMaskedAadhaarCard, useZipCodeLabel } = useDomainFeatures();
    const admissionFieldLabel = useStudentIdLabel ? "Student Id" : "Admission Number";
    const admissionFieldLabelRequired = `${admissionFieldLabel} `;
    const enrollmentDateLabel = useEnrollmentDateLabel
      ? "Enrollment Date"
      : "Date Of Admission";
    var [error, setError] = useState(null);
    const [age, setAge] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const [cityList, setCityList] = useState([]);
    const [imageslist, setImagesList] = useState([]);
    const [imageslist1, setImagesList1] = useState('');
    const [birthCertificateUrl, setBirthCertificateUrl] = useState('');
    const [hasAllergies, setHasAllergies] = useState('no'); // yes/no
    const [allergyItems, setAllergyItems] = useState(['']);
    const [authorizedPickupItems, setAuthorizedPickupItems] = useState([
        { name: '', mobileNumber: '', photoURL: '' },
    ]);
    const [authorizedPickupFilesByIndex, setAuthorizedPickupFilesByIndex] = useState({});
    const [profileFillMode, setProfileFillMode] = useState('parent'); // school | parent
    const isParentFillMode = profileFillMode === 'parent';
    const [parentMode, setParentMode] = useState('new'); // new | existing
    const [parentList, setParentList] = useState([]);
    const [selectedParentId, setSelectedParentId] = useState('');
    const [step, setStep] = useState(1); // 1=Student Details, 2=Parent Details
    const [parentMetaById, setParentMetaById] = useState({}); // { [parentId]: { fatherName, motherName, children: [{_id, name, className}] } }
    const [existingAdmissionNumbers, setExistingAdmissionNumbers] = useState(new Set());

    const [message, setMessage] = useState("");
    const [message1, setMessage1] = useState("");
    const [birthCertificateMessage, setBirthCertificateMessage] = useState("");

    const [images, setImages] = useState('');
    const [images1, setImages1] = useState('');
    const [birthCertificateFile, setBirthCertificateFile] = useState('');

    const classes = useStyles();
    const [gender, setGender] = useState("");
    const [studentList, setStudentList] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [student, setStudent] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        dob: '',
        motherName: '',
        fatherName: '',
        motherEmail: '',
        fatherEmail: '',
        mobileNumber: '',
        parentUserName: '',
        authorizedPickupName: '',
        authorizedPickupMobileNumber: '',
        authorizedPickups: [],
        specialNeeds: '',
        address: '',
        lane: '',
        // selectCity: '',
        doa: '',
        allergies: '',
        classId: '',
        sectionId: '',
        fatherMobileNumber: '',
        admissionNumber: '',
        gender: '',
        adharNo: '',
        zipCode: '',
        status: true,
    });

    const city = [
        'Mumbai',
        'Delhi',
        'Bagolore',
        'Hyderbad',
        'Chennai',
    ];
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    useEffect(() => {
        getAddClassList();
        loadParentsForSchool();
        loadExistingAdmissionNumbers();
        if (id !== 'add') {
            getByIdList();
        }
        return () => {
            setStudentList([]);
        }
    }, []);

    const loadExistingAdmissionNumbers = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schoolId = userDetails?.schooleId;
        if (!schoolId) {
            setExistingAdmissionNumbers(new Set());
            return;
        }
        try {
            const res = await StudentService.findStudentList({ schooleId: schoolId });
            const list = Array.isArray(res) ? res : [];
            const numbers = new Set();
            for (const s of list) {
                const num = s?.admissionNumber ? String(s.admissionNumber).trim().toLowerCase() : '';
                if (num) numbers.add(num);
            }
            setExistingAdmissionNumbers(numbers);
        } catch {
            setExistingAdmissionNumbers(new Set());
        }
    };

    const loadParentsForSchool = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schoolId = userDetails?.schooleId;
        if (!schoolId) {
            setParentList([]);
            return;
        }
        // UserService.getAllUsers()
        //     .then((res) => {
        //         const list = Array.isArray(res) ? res : [];
        //         const parents = list
        //             .filter((u) => String(u?.role || '').toUpperCase() === 'PARENT')
        //             .filter((u) => String(u?.schooleId || '') === String(schoolId))
        //             .map((u) => ({
        //                 _id: u._id,
        //                 mobile: u.mobile || '',
        //                 userName: u.userName || '',
        //                 serialNumber: u.serialNumber || '',
        //             }))
        //             .filter((u) => u._id && u.mobile);
        //         setParentList(parents);
        //         preloadParentNamesFromStudents(schoolId);
        //     })
        //     .catch(() => setParentList([]));
    };

    const preloadParentNamesFromStudents = async (schoolId) => {
        if (!schoolId) return;
        try {
            const res = await StudentService.findStudentList({ schooleId: schoolId });
            const list = Array.isArray(res) ? res : [];

            const nameMap = {};
            for (const s of list) {
                const parentId = s?.userId?._id || s?.userId;
                if (!parentId) continue;
                const pid = String(parentId);
                if (nameMap[pid]) continue;
                nameMap[pid] = {
                    fatherName: s?.fatherName ? String(s.fatherName).trim() : '',
                    motherName: s?.motherName ? String(s.motherName).trim() : '',
                };
            }

            setParentMetaById((prev) => {
                const next = { ...(prev || {}) };
                for (const [pid, names] of Object.entries(nameMap)) {
                    const existing = next[pid] || {};
                    next[pid] = {
                        ...existing,
                        fatherName: existing.fatherName || names.fatherName || '',
                        motherName: existing.motherName || names.motherName || '',
                    };
                }
                return next;
            });
        } catch {
            // ignore
        }
    };

    const loadParentMeta = async (parentId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schoolId = userDetails?.schooleId;
        if (!parentId || !schoolId) return;
        // We may preload only father/mother names without children, or have an empty children list for older records.
        // Only skip fetching if we already have a non-empty children list.
        const existing = parentMetaById?.[parentId];
        if (existing && Array.isArray(existing.children) && existing.children.length > 0) return;

        try {
            const res = await StudentService.findStudentList({ schooleId: schoolId, userId: parentId });
            const list = Array.isArray(res) ? res : [];
            const first = list[0] || {};
            const fatherName = first?.fatherName ? String(first.fatherName).trim() : '';
            const motherName = first?.motherName ? String(first.motherName).trim() : '';
            const children = list.map((s) => ({
                _id: s?._id,
                name: `${s?.firstName || ''} ${s?.middleName || ''} ${s?.lastName || ''}`.replace(/\s+/g, ' ').trim(),
                className: s?.classId && typeof s.classId === 'object' ? s.classId.className : '',
                userName:
                    s?.userId && typeof s.userId === 'object'
                        ? (s.userId.userName || s.userId.serialNumber || '')
                        : '',
            }));

            setParentMetaById((prev) => ({
                ...prev,
                [parentId]: { fatherName, motherName, children },
            }));
        } catch {
            // ignore
        }
    };
    const handleChange = (student) => {
        setAge(student.target.value);
    };
    const handleChange1 = (event) => {
        setGender(event.target.value);
    };
    const handleOpen = () => {
        props.history.push('/app/district/studentdetails')
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleGoBack = () => {
        if (props.history && props.history.push) {
            props.history.push('/app/studentdetails');
        } else if (routerHistory && routerHistory.push) {
            routerHistory.push('/app/studentdetails');
        } else {
            window.history.back();
        }
    };
    const getByIdList = () => {
        StudentService.getByIdStudent(id).then((res) => {

            const normalizedGender = res?.gender != null ? String(res.gender).trim().toLowerCase() : '';
            setStudent({
                ...res,
                // Ensure selects receive plain ids (not populated objects)
                classId: res?.classId && typeof res.classId === 'object' ? (res.classId?._id || '') : (res?.classId || ''),
                sectionId: res?.sectionId && typeof res.sectionId === 'object' ? (res.sectionId?._id || '') : (res?.sectionId || ''),
                // Excel upload saves "aadharNo"; UI historically used "adharNo"
                adharNo: res?.adharNo || res?.aadharNo || '',
                zipCode: res?.zipCode || '',
                parentUserName:
                    res?.userId && typeof res.userId === 'object'
                        ? (res.userId.userName || res.userId.serialNumber || '')
                        : '',
                // Radio values are "male"/"female"
                gender:
                    normalizedGender === 'male' || normalizedGender === 'female'
                        ? normalizedGender
                        : normalizedGender,
                status: res?.status !== false,
            });
            const galleryUrls = Array.isArray(res?.imageURL)
                ? res.imageURL
                : res?.imageURL
                    ? [res.imageURL]
                    : [];
            setImagesList(galleryUrls.map((u) => String(u || '').trim()).filter(Boolean));
            setImagesList1(res?.profileURL || '');
            setBirthCertificateUrl(res?.birthCertificateURL || '');
            setProfileFillMode(location.state?.profileFillMode || 'parent');
            setIsEditMode(true);
            setEditId(id);

            const rawAllergies = String(res?.allergies || '').trim();
            if (!rawAllergies || rawAllergies.toLowerCase() === 'no') {
                setHasAllergies('no');
                setAllergyItems(['']);
            } else {
                setHasAllergies('yes');
                const parts = rawAllergies
                    .split(',')
                    .map((s) => String(s).trim())
                    .filter(Boolean);
                setAllergyItems(parts.length ? parts : ['']);
            }
            // When editing, start on student details step
            setStep(1);

            const ap = Array.isArray(res?.authorizedPickups) ? res.authorizedPickups : [];
            if (ap.length) {
                setAuthorizedPickupItems(
                    ap.map((p) => ({
                        name: p?.name ? String(p.name) : '',
                        mobileNumber: p?.mobileNumber ? String(p.mobileNumber) : '',
                        photoURL: p?.photoURL ? String(p.photoURL) : '',
                    }))
                );
            } else {
                const fallbackName = res?.authorizedPickupName ? String(res.authorizedPickupName) : '';
                const fallbackMobile = res?.authorizedPickupMobileNumber ? String(res.authorizedPickupMobileNumber) : '';
                if (fallbackName || fallbackMobile) {
                    setAuthorizedPickupItems([{ name: fallbackName, mobileNumber: fallbackMobile, photoURL: '' }]);
                } else {
                    setAuthorizedPickupItems([{ name: '', mobileNumber: '', photoURL: '' }]);
                }
            }
        }).catch((err) => {
            setError(err.message);
        });
    }

    const handleFileChange = (e) => {
        setImages(e.target.files); // Store all selected files in state
    };
    const handleFileChange1 = (e) => {
        setImages1(e.target.files); // Store all selected files in state
    };
    const handleBirthCertificateFileChange = (e) => {
        setBirthCertificateFile(e.target.files); // optional
    };

    const getImageListArray = (list) => {
        if (Array.isArray(list)) return list.map((u) => String(u || '').trim()).filter(Boolean);
        if (typeof list === 'string' && list.trim()) return [list.trim()];
        return [];
    };

    const removeGalleryImage = async (index) => {
        const urls = getImageListArray(imageslist);
        const url = urls[index];
        if (url && /^https?:\/\//i.test(url)) {
            try {
                await StudentService.deleteAzureImage({ imageURL: url });
            } catch (err) {
                console.error('Failed to delete image from Azure:', err);
            }
        }
        setImagesList(urls.filter((_, i) => i !== index));
        setMessage('');
    };

    const removeProfilePhoto = async () => {
        const url = String(imageslist1 || '').trim();
        if (url && /^https?:\/\//i.test(url)) {
            try {
                await StudentService.deleteAzureImage({ imageURL: url });
            } catch (err) {
                console.error('Failed to delete profile photo from Azure:', err);
            }
        }
        setImagesList1('');
        setImages1('');
        setMessage1('');
        const input = document.getElementById('student-profile-photo');
        if (input) input.value = '';
    };
    const validationSchema = useMemo(() => Yup.object().shape({
        admissionNumber: Yup.string()
            .trim()
            .required(`${admissionFieldLabel} is required`)
            .test(
                'unique-admission',
                `This ${admissionFieldLabel.toLowerCase()} is already in use`,
                function (value) {
                    if (!value) return true;
                    const normalized = String(value).trim().toLowerCase();
                    const currentAdmission = student?.admissionNumber
                        ? String(student.admissionNumber).trim().toLowerCase()
                        : '';
                    if (student?._id && currentAdmission === normalized) {
                        return true;
                    }
                    return !existingAdmissionNumbers.has(normalized);
                }
            ),
        firstName: Yup.string().required('student first name  is required'),
        middleName: Yup.string(),
        lastName: Yup.string(),
        gender: Yup.string(),
        adharNo: hideAadhaarNumber
            ? Yup.string()
            : Yup.string()
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(12, 'Must be exactly 12 digits')
            .max(12, 'Must be exactly 12 digits'),
        zipCode: Yup.string(),
        dob: Yup.string().required('select date of birth'),
        classId: Yup.string().required('select class'),
        sectionId: Yup.string(),
        motherName: Yup.string().required('mother name  is required'),
        fatherName: Yup.string()
            // Allow common formats like "K. RAMYA", "RAVI-KUMAR", "A/B" if needed; keep it permissive for existing data.
            .matches(/^[a-zA-Z.\-'\s]*$/, 'Father name contains invalid characters')
            .nullable(),
        motherEmail: Yup.string()
            .trim()
            .test('email', 'Enter a valid  Gmail / email', (value) => {
                if (!value || !String(value).trim()) return true;
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
            }),
        fatherEmail: Yup.string()
            .trim()
            .test('email', 'Enter a valid  Gmail / email', (value) => {
                if (!value || !String(value).trim()) return true;
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
            }),
        mobileNumber: Yup.string(),
        authorizedPickupName: Yup.string(),
        authorizedPickupMobileNumber: Yup.string(),
        specialNeeds: Yup.string(),
        address: Yup.string(),
        lane: Yup.string(),
        // selectCity: Yup.string().required('select city'),
        doa: Yup.string().required(`select ${enrollmentDateLabel.toLowerCase()}`),
        allergies: Yup.string(),

    }), [existingAdmissionNumbers, student._id, student.admissionNumber, admissionFieldLabel, enrollmentDateLabel]);


    const getStudentList = () => {
        StudentService.getAllStudent().then((res) => {
            setStudentList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        AddClassService.getAllAddClass(userDetails.schooleId)
            .then((res) => {
                const list = Array.isArray(res) ? res : [];
                const map = new Map();
                for (const item of list) {
                    const key = String(item?.className || "").trim().toLowerCase();
                    if (!key) continue;
                    if (!map.has(key)) map.set(key, item);
                }
                const unique = Array.from(map.values()).sort((a, b) =>
                    String(a?.className || "").localeCompare(String(b?.className || ""))
                );
                setAddClassList(unique);
            })
            .catch(() => {
                setAddClassList([]);
            });
    }

    const getSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };
    const getPreviewClassName = () => {
        const selectedId = formik.values.classId;
        if (!selectedId) return "Not provided";
        const found = addClassList.find((cls) => {
            const id = cls?._id || cls?.id || "";
            return String(id) === String(selectedId);
        });
        return found?.className || selectedId || "Not provided";
    };
    const handleUpload = async (e) => {
        e.preventDefault();

        if (images.length === 0) {
            setMessage("Please select images first.");
            return;
        }

        // Create FormData and append each file
        const formData = new FormData();
        if (images.length > 0) {
            const image = images[0];
            formData.append(`image`, image);

            formData.append(`imageName`, image.name);
            // images.forEach((image, index) => {
            //   formData.append(`images`, image); // Append each file to the form
            // });

            try {
                // Send the images to the API
                StudentService.uploadImage(formData).then((res) => {
                    const url = res?.url || res?.data?.url;
                    if (!url) {
                        alert('Upload succeeded but no image URL returned.');
                        return;
                    }
                    alert('Image uploaded successfully');
                    setImagesList((prev) => [...getImageListArray(prev), url]);
                    setMessage('');
                }).catch((err) => {
                    alert(err?.response?.data?.message || err.message || 'Upload failed');
                });
            } catch (error) {
                console.error("Error uploading images:", error);
                setMessage("An error occurred while uploading the images.");
            }
        }

    };
    const handleUpload1 = async (e) => {
        e.preventDefault();

        if (images1.length === 0) {
            setMessage1("Please select images first.");
            return;
        }

        // Create FormData and append each file
        const formData = new FormData();
        if (images1.length > 0) {
            const image = images1[0];
            formData.append(`image`, image);

            formData.append(`imageName`, image.name);
            // images.forEach((image, index) => {
            //   formData.append(`images`, image); // Append each file to the form
            // });

            try {
                // Send the images to the API
                StudentService.uploadImage(formData).then((res) => {
                    const url = res?.url || res?.data?.url;
                    if (!url) {
                        alert('Upload succeeded but no image URL returned.');
                        return;
                    }
                    alert('Profile photo uploaded successfully');
                    setImagesList1(url);
                    setMessage1('');
                }).catch((err) => {
                    alert(err?.response?.data?.message || err.message || 'Upload failed');
                });
            } catch (error) {
                console.error("Error uploading images:", error);
                setMessage("An error occurred while uploading the images.");
            }
        }

    };

    const handleBirthCertificateUpload = async (e) => {
        e.preventDefault();

        if (!birthCertificateFile || birthCertificateFile.length === 0) {
            setBirthCertificateMessage("Please select a file first.");
            return;
        }

        const formData = new FormData();
        const file = birthCertificateFile[0];
        formData.append(`image`, file);
        formData.append(`imageName`, file.name);

        try {
            StudentService.uploadImage(formData)
                .then((res) => {
                    const url = res?.url || res?.data?.url;
                    if (!url) {
                        alert('Upload succeeded but no image URL returned.');
                        return;
                    }
                    alert('Birth certificate uploaded successfully');
                    setBirthCertificateUrl(url);
                    setBirthCertificateMessage('');
                })
                .catch((err) => {
                    alert(err.message);
                });
        } catch (error) {
            console.error("Error uploading birth certificate:", error);
            setBirthCertificateMessage("An error occurred while uploading the birth certificate.");
        }
    };

    const addAllergyItem = () => {
        setAllergyItems((prev) => [...prev, '']);
    };
    const removeAllergyItem = (index) => {
        setAllergyItems((prev) => {
            const next = prev.filter((_, i) => i !== index);
            return next.length ? next : [''];
        });
    };
    const updateAllergyItem = (index, value) => {
        setAllergyItems((prev) => prev.map((v, i) => (i === index ? value : v)));
    };

    const addAuthorizedPickupItem = () => {
        setAuthorizedPickupItems((prev) => [...prev, { name: '', mobileNumber: '', photoURL: '' }]);
    };
    const removeAuthorizedPickupItem = (index) => {
        setAuthorizedPickupItems((prev) => {
            const next = prev.filter((_, i) => i !== index);
            return next.length ? next : [{ name: '', mobileNumber: '', photoURL: '' }];
        });
        setAuthorizedPickupFilesByIndex((prev) => {
            const next = { ...(prev || {}) };
            delete next[index];
            return next;
        });
    };
    const updateAuthorizedPickupItem = (index, patch) => {
        setAuthorizedPickupItems((prev) =>
            prev.map((v, i) => (i === index ? { ...v, ...(patch || {}) } : v))
        );
    };
    const handleAuthorizedPickupFileChange = (index, e) => {
        const files = e?.target?.files;
        setAuthorizedPickupFilesByIndex((prev) => ({ ...(prev || {}), [index]: files }));
    };
    const handleAuthorizedPickupPhotoUpload = async (index, e) => {
        e.preventDefault();
        const files = authorizedPickupFilesByIndex?.[index];
        if (!files || files.length === 0) {
            alert("Please select an image first.");
            return;
        }
        const file = files[0];
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageName', file.name);
        try {
            const res = await StudentService.uploadImage(formData);
            const url = res?.url || res?.data?.url;
            if (!url) {
                alert('Upload succeeded but no image URL returned.');
                return;
            }
            updateAuthorizedPickupItem(index, { photoURL: url });
            alert("Authorized pickup photo uploaded successfully");
        } catch (err) {
            alert(err?.message || "Failed to upload photo");
        }
    };
    const deleteStudent = (studentdelete) => {
        if (studentdelete) {
            StudentService.deleteStudent(studentdelete).then((res) => {
                getStudentList();
            }).catch((err) => {
            });
        }
    };
    const getStudentImageList = (studentId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        const keys = {
            "schooleId": userDetails.schooleId,

            "studentId": userDetails.studentId
        }
        StudentService.creteImages(keys).then((res) => {

            //   setStudentList([]);
            alert(" Event Successfully.");
        }).catch((err) => {

        });
    }
    const applyProfileFieldsToPayload = (values, isEdit) => {
        values.parentProfilePending = isParentFillMode;

        if (!isParentFillMode) {
            values.imageURL = isEdit ? (imageslist || student.imageURL || []) : imageslist;
            values.profileURL = isEdit ? (imageslist1 || student.profileURL || '') : imageslist1;
            values.birthCertificateURL = isEdit
                ? (birthCertificateUrl || student.birthCertificateURL || '')
                : (birthCertificateUrl || '');
            values.allergies =
                hasAllergies === 'yes'
                    ? allergyItems.map((s) => String(s).trim()).filter(Boolean).join(', ')
                    : 'no';
            values.authorizedPickups = (authorizedPickupItems || [])
                .map((p) => ({
                    name: p?.name ? String(p.name).trim() : '',
                    mobileNumber: p?.mobileNumber ? String(p.mobileNumber).trim() : '',
                    photoURL: p?.photoURL ? String(p.photoURL).trim() : '',
                }))
                .filter((p) => p.name || p.mobileNumber || p.photoURL);
            return values;
        }

        if (isEdit) {
            delete values.imageURL;
            delete values.profileURL;
            delete values.birthCertificateURL;
            delete values.allergies;
            delete values.authorizedPickups;
            delete values.specialNeeds;
            delete values.address;
            delete values.adharNo;
            delete values.aadharNo;
            delete values.zipCode;
            return values;
        }

        values.imageURL = [];
        values.profileURL = '';
        values.birthCertificateURL = '';
        values.allergies = 'no';
        values.authorizedPickups = [];
        values.specialNeeds = '';
        values.address = '';
        values.adharNo = '';
        delete values.aadharNo;
        return values;
    };

    const formik = useFormik({
        initialValues: student,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            if (values.admissionNumber != null) {
                values.admissionNumber = String(values.admissionNumber).trim();
            }
            // Backend schema uses "aadharNo" (Excel upload writes that). Keep both for backward compatibility.
            if (values.adharNo != null && values.adharNo !== '') {
                values.aadharNo = values.adharNo;
            }
            // Normalize gender to match radio values + backend expectations
            if (values.gender != null) {
                values.gender = String(values.gender).trim().toLowerCase();
            }
            values.status = values.status !== false && values.status !== 'false';
            if (values.parentUserName != null) {
                values.parentUserName = String(values.parentUserName).trim();
            }
            if (values.motherEmail != null) {
                values.motherEmail = String(values.motherEmail).trim();
            }
            if (values.fatherEmail != null) {
                values.fatherEmail = String(values.fatherEmail).trim();
            }
            // Backend expects ObjectId or omit; empty string causes "Cast to ObjectId" error
            if (!values.sectionId || String(values.sectionId).trim() === '') {
                delete values.sectionId;
            }
            if (student._id) {
                applyProfileFieldsToPayload(values, true);
                StudentService.upadeStudent(values).then((res) => {
                    setImagesList([])
                    alert("Student Registration Updated Successfully.");
                    props.history.push('/app/studentdetails');

                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }
            else {
                applyProfileFieldsToPayload(values, false);
                StudentService.creteStudent(values).then((res) => {
                    setImagesList([])
                    alert(" Student Registration Successfully.");
                    props.history.push('/app/studentdetails');
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {

                        alert(err.response.data.message)
                    })
            }
        },
    });

    const goToParentStep = async () => {
        // Validate only student/basic fields before moving to parent step
        const fieldsToTouch = ['firstName', 'middleName', 'lastName', 'dob', 'doa', 'classId', 'sectionId', 'admissionNumber', 'gender'];
        fieldsToTouch.forEach((f) => formik.setFieldTouched(f, true, false));
        const errors = await formik.validateForm();
        const hasBasicErrors = fieldsToTouch.some((f) => Boolean(errors?.[f]));
        if (!hasBasicErrors) {
            setStep(2);
        }
    };

    useEffect(() => {
        // Whenever selected class changes (including when editing an existing student),
        // load the corresponding sections so the section dropdown is populated.
        if (formik.values.classId) {
            getSectionListByClass(formik.values.classId);
        } else {
            setSectionList([]);
        }
    }, [formik.values.classId]);

    return (
        <>
            <Card sx={{ maxWidth: 'none', margin: '20px', padding: '20px' }}>
                <Box>
                    <div style={{ padding: '0 20px' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    style={{ gap: 12, marginBottom: 8, marginTop: 4 }}
                                >
                                    <IconButton
                                        onClick={handleGoBack}
                                        size="small"
                                        style={{
                                            backgroundColor: '#0f3b62',
                                            color: '#fff',
                                            padding: 8,
                                        }}
                                        aria-label="Go back"
                                    >
                                        <ArrowBackIcon fontSize="small" />
                                    </IconButton>
                                    <Typography
                                        variant="h4"
                                        style={{ color: '#10b680', fontWeight: 600, fontSize: '1.5rem' }}
                                    >
                                        {id !== 'add' ? 'Edit Student Registration' : 'Student Registration'}
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box
                                    style={{
                                        padding: '12px 16px',
                                        borderRadius: 8,
                                        border: '1px solid #d6e4ff',
                                        backgroundColor: '#eef4ff',
                                    }}
                                >
                                    <FormControl component="fieldset" fullWidth>
                                        <FormLabel component="legend" style={{ color: '#0f2d4d', fontWeight: 700, marginBottom: 8 }}>
                                            Profile details — who will fill them?
                                        </FormLabel>
                                        <Typography variant="body2" style={{ color: '#46566b', marginBottom: 10 }}>
                                            Photo, authorized pickup, {hideAadhaarNumber ? "ZIP code, " : "Aadhaar number, "}address, special needs, documents, and allergies can be completed by the school now or left for the parent in the parent app.{hideAadhaarNumber ? " Social Security Number is optional and can be added by the parent." : ""}
                                        </Typography>
                                        <RadioGroup
                                            row
                                            name="profileFillMode"
                                            value={profileFillMode}
                                            onChange={(e) => setProfileFillMode(e.target.value)}
                                        >
                                            <FormControlLabel value="parent" control={<Radio color="primary" />} label="Parent fills in parent app" />
                                            <FormControlLabel value="school" control={<Radio color="primary" />} label="School fills now" />
                                        </RadioGroup>
                                        {isParentFillMode ? (
                                            <Typography variant="body2" style={{ color: '#1769d6', marginTop: 8, fontWeight: 600 }}>
                                                These details will be completed by the parent after login. You can register the student with basic and parent contact information only.
                                            </Typography>
                                        ) : null}
                                    </FormControl>
                                </Box>
                            </Grid>

                            {!isParentFillMode ? (
                            <>
                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad' }}>Upload Student Photo:</span>
                            </Grid>
                            <Grid item xs={12}>
                                <input
                                    id="student-profile-photo"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange1}
                                />
                                <Button
                                    style={{
                                        backgroundColor: 'rgb(15 59 98)',
                                        color: 'white',
                                        border: 'none',
                                        marginLeft: 8,
                                    }}
                                    onClick={handleUpload1}
                                >
                                    Upload
                                </Button>
                                {message1 ? (
                                    <Typography variant="caption" color="error" style={{ display: 'block', marginTop: 6 }}>
                                        {message1}
                                    </Typography>
                                ) : null}
                                {imageslist1 ? (
                                    <Box mt={2} style={{ display: 'inline-block', position: 'relative' }}>
                                        <img
                                            src={imageslist1}
                                            alt="Student profile"
                                            style={{
                                                width: 120,
                                                height: 120,
                                                objectFit: 'cover',
                                                borderRadius: 8,
                                                border: '1px solid #e2e8f0',
                                                display: 'block',
                                            }}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={removeProfilePhoto}
                                            style={{
                                                position: 'absolute',
                                                top: 4,
                                                right: 4,
                                                backgroundColor: 'rgba(255,255,255,0.95)',
                                                padding: 4,
                                            }}
                                            aria-label="Remove profile photo"
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                        <Button
                                            size="small"
                                            color="secondary"
                                            variant="contained"
                                            startIcon={<DeleteIcon />}
                                            onClick={removeProfilePhoto}
                                            style={{ marginTop: 8 }}
                                        >
                                            Remove Photo
                                        </Button>
                                    </Box>
                                ) : null}
                            </Grid>
                            </>
                            ) : null}
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField fullWidth
                                    margin="dense"
                                    id="admissionNumber"
                                    name="admissionNumber"
                                    label={admissionFieldLabelRequired}
                                    type="text"
                                    required
                                    autoFocus
                                    variant="outlined"
                                    value={formik.values.admissionNumber}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.admissionNumber && Boolean(formik.errors.admissionNumber)}
                                    helperText={formik.touched.admissionNumber && formik.errors.admissionNumber}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <SchoolDatePicker
                                    id="dob"
                                    name="dob"
                                    label="Date Of Birth"
                                    required
                                    value={formik.values.dob}
                                    onChange={(iso) => formik.setFieldValue("dob", iso)}
                                    error={formik.touched.dob && Boolean(formik.errors.dob)}
                                    helperText={formik.touched.dob && formik.errors.dob}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={4}>
                                <TextField fullWidth
                                    margin="dense"
                                    id="firstName"
                                    name="firstName"
                                    label="First Name "
                                    required
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.firstName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                    helperText={formik.touched.firstName && formik.errors.firstName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                <TextField fullWidth
                                    margin="dense"
                                    id="middleName"
                                    name="middleName"
                                    label="Middle Name (Optional)"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.middleName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.middleName && Boolean(formik.errors.middleName)}
                                    helperText={formik.touched.middleName && formik.errors.middleName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                <TextField fullWidth
                                    margin="dense"
                                    id="lastName"
                                    name="lastName"
                                    label="Last Name "
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                    helperText={formik.touched.lastName && formik.errors.lastName}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Gender</FormLabel>
                                    <RadioGroup
                                        row
                                        name="gender"
                                        id="gender"
                                        value={formik.values.gender}
                                        onChange={formik.handleChange}
                                    >
                                        <FormControlLabel value="male" control={<Radio />} label="Male" />
                                        <FormControlLabel value="female" control={<Radio />} label="Female" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <SchoolDatePicker
                                    id="doa"
                                    name="doa"
                                    label={enrollmentDateLabel}
                                    required
                                    value={formik.values.doa}
                                    onChange={(iso) => formik.setFieldValue("doa", iso)}
                                    error={formik.touched.doa && Boolean(formik.errors.doa)}
                                    helperText={formik.touched.doa && formik.errors.doa}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl 
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    required
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <InputLabel id="class-select-label">Select Class</InputLabel>
                                    <Select
                                        labelId="class-select-label"
                                        id="class-select"
                                        name="classId"
                                        label="Classroom/Level"
                                        value={formik.values.classId}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            getSectionListByClass(e.target.value);
                                            // Reset section when class changes
                                            formik.setFieldValue("sectionId", "");
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.classId && formik.errors.classId && (
                                        <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4 }}>
                                            {formik.errors.classId}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                >
                                    <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                                    <Select
                                        labelId="section-select-label"
                                        id="section-select"
                                        name="sectionId"
                                        label="Select Section (Optional)"
                                        value={formik.values.sectionId || ""}
                                        onChange={formik.handleChange}
                                        disabled={!formik.values.classId || sectionList.length === 0}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {sectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl component="fieldset" style={{ marginTop: 8 }}>
                                    <FormLabel component="legend">Status</FormLabel>
                                    <RadioGroup
                                        row
                                        name="status"
                                        id="status"
                                        value={
                                            formik.values.status === false || formik.values.status === 'false'
                                                ? 'false'
                                                : 'true'
                                        }
                                        onChange={(e) =>
                                            formik.setFieldValue('status', e.target.value === 'true')
                                        }
                                    >
                                        <FormControlLabel value="true" control={<Radio />} label="Active" />
                                        <FormControlLabel value="false" control={<Radio />} label="Inactive" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {step === 2 ? (
                                <Grid item xs={12} style={{ marginTop: '30px' }}>
                                    <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Parent Details:</span>
                                </Grid>
                            ) : null}
                            {/* {step === 2 ? (
                            <Grid item xs={12}>
                                <FormControl component="fieldset" style={{ marginTop: 8 }}>
                                    <FormLabel component="legend">Parent already exists?</FormLabel>
                                    <RadioGroup
                                        row
                                        name="parentMode"
                                        value={parentMode}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setParentMode(val);
                                            setSelectedParentId('');
                                            if (val === 'new') {
                                                formik.setFieldValue('mobileNumber', '');
                                            }
                                        }}
                                    >
                                        <FormControlLabel value="existing" control={<Radio />} label="Yes (select parent)" />
                                        <FormControlLabel value="new" control={<Radio />} label="No (create new parent)" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            ) : null} */}

                            {step === 2 && parentMode === 'existing' ? (
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl fullWidth margin="dense" variant="outlined">
                                        <InputLabel id="parent-select-label">Select Parent</InputLabel>
                                        <Select
                                            labelId="parent-select-label"
                                            id="parent-select"
                                            name="selectedParentId"
                                            label="Select Parent"
                                            value={selectedParentId}
                                            onChange={(e) => {
                                                const pid = e.target.value;
                                                setSelectedParentId(pid);
                                                if (pid) loadParentMeta(pid);
                                                const selected = parentList.find((p) => String(p._id) === String(pid));
                                                if (selected?.mobile) {
                                                    formik.setFieldValue('mobileNumber', selected.mobile);
                                                }
                                                if (selected?.userName) {
                                                    formik.setFieldValue('parentUserName', selected.userName);
                                                } else if (selected?.serialNumber) {
                                                    formik.setFieldValue('parentUserName', selected.serialNumber);
                                                }
                                            }}
                                            renderValue={(val) => {
                                                const pid = val;
                                                const p = parentList.find((x) => String(x._id) === String(pid));
                                                const username = p?.userName ? p.userName : '';
                                                const mobile = p?.mobile ? p.mobile : '';
                                                return `${username}${username && mobile ? ' — ' : ''}${mobile}` || 'Select Parent';
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {parentList.map((p) => {
                                                const meta = parentMetaById?.[p._id];
                                                const father = meta?.fatherName ? `Father: ${meta.fatherName}` : '';
                                                const mother = meta?.motherName ? `Mother: ${meta.motherName}` : '';
                                                const mobile = p?.mobile ? `Mobile: ${p.mobile}` : '';
                                                const parts = [father, mother, mobile].filter(Boolean).join(' | ');
                                                const prefix = parts ? `${parts} — ` : '';
                                                return (
                                                <MenuItem key={p._id} value={p._id}>
                                                    {prefix}{p.userName ? `${p.userName} — ` : ''}{p.mobile}{p.serialNumber ? ` — ${p.serialNumber}` : ''}
                                                </MenuItem>
                                            )})}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            ) : null}

                            {step === 2 && parentMode === 'existing' && selectedParentId ? (
                                <Grid item xs={12}>
                                    <Box
                                        component="span"
                                        display="block"
                                        mt={1}
                                        px={1.5}
                                        py={1}
                                        borderRadius={1}
                                        bgcolor="rgba(15, 59, 98, 0.06)"
                                        borderLeft="3px solid rgb(15 59 98)"
                                    >
                                        <Typography variant="body2" style={{ fontWeight: 700, color: '#0f3b62' }}>
                                            Parent Selected: {parentMetaById?.[selectedParentId]?.fatherName || parentMetaById?.[selectedParentId]?.motherName || '—'}
                                        </Typography>
                                        <Typography variant="caption" style={{ color: '#0f3b62ad' }}>
                                            Existing Children:
                                        </Typography>
                                        <ul style={{ marginTop: 6, marginBottom: 0, paddingLeft: 18 }}>
                                            {(parentMetaById?.[selectedParentId]?.children || []).slice(0, 10).map((c) => (
                                                <li key={c._id || c.name}>
                                                    <Typography variant="caption">
                                                        {c.name || '—'}
                                                        {c.userName ? ` — ${c.userName}` : ''}
                                                        {c.className ? ` (${c.className})` : ''}
                                                    </Typography>
                                                </li>
                                            ))}
                                            {(parentMetaById?.[selectedParentId]?.children || []).length === 0 ? (
                                                <li>
                                                    <Typography variant="caption">—</Typography>
                                                </li>
                                            ) : null}
                                        </ul>
                                    </Box>
                                </Grid>
                            ) : null}
                            {step === 2 ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="motherName"
                                    name="motherName"
                                    label="Mother Name"
                                    required
                                    type="text"
                                   
                                    variant="outlined"
                                    value={formik.values.motherName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.motherName && Boolean(formik.errors.motherName)}
                                    helperText={formik.touched.motherName && formik.errors.motherName}
                                />
                            </Grid>
                            ) : null}
                            {step === 2 ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="fatherName"
                                    name="fatherName"
                                    label="Father Name"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.fatherName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.fatherName && Boolean(formik.errors.fatherName)}
                                    helperText={formik.touched.fatherName && formik.errors.fatherName}
                                />
                            </Grid>
                            ) : null}
                            {/* {step === 2 ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="parentUserName"
                                    name="parentUserName"
                                    label="Parent User Name"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.parentUserName || ""}
                                    onChange={formik.handleChange}
                                    disabled={parentMode === 'existing' && !selectedParentId}
                                />
                            </Grid>
                            ) : null} */}
                            {step === 2 ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="motherEmail"
                                    name="motherEmail"
                                    label="Primary Gmail / Email "
                                    required
                                    type="email"
                                    variant="outlined"
                                    value={formik.values.motherEmail || ''}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.motherEmail && Boolean(formik.errors.motherEmail)}
                                    helperText={formik.touched.motherEmail && formik.errors.motherEmail}
                                />
                            </Grid>
                            ) : null}
                            {step === 2 ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="fatherEmail"
                                    name="fatherEmail"
                                    label="Secondary Gmail / Email"
                                    type="email"
                                    variant="outlined"
                                    value={formik.values.fatherEmail || ''}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.fatherEmail && Boolean(formik.errors.fatherEmail)}
                                    helperText={formik.touched.fatherEmail && formik.errors.fatherEmail}
                                />
                            </Grid>
                            ) : null}
                            {step === 2 ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="mobileNumber"
                                    name="mobileNumber"
                                    label="Parent Mobile Number "
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.mobileNumber}
                                    onChange={formik.handleChange}
                                    disabled={parentMode === 'existing'}
                                    error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                                    helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                                />
                            </Grid>
                            ) : null}

                            {step === 2 && !isParentFillMode ? (<Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >
                                    Authorized Pickup (Optional):
                                </span>
                            </Grid>) : null}
                            {step === 2 && !isParentFillMode ? (
                                <Grid item xs={12}>
                                    <Box style={{ marginTop: 8 }}>
                                        {(authorizedPickupItems || []).map((p, idx) => (
                                            <Box
                                                key={idx}
                                                style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 12,
                                                    alignItems: 'center',
                                                    marginBottom: 12,
                                                    padding: 10,
                                                    border: '1px solid rgba(15, 59, 98, 0.15)',
                                                    borderRadius: 8,
                                                }}
                                            >
                                                <TextField
                                                    style={{ flex: '1 1 240px' }}
                                                    margin="dense"
                                                    label={`Pickup Name ${idx + 1}`}
                                                    type="text"
                                                    variant="outlined"
                                                    value={p?.name || ''}
                                                    onChange={(e) => updateAuthorizedPickupItem(idx, { name: e.target.value })}
                                                />
                                                <TextField
                                                    style={{ flex: '1 1 240px' }}
                                                    margin="dense"
                                                    label="Mobile Number"
                                                    type="text"
                                                    variant="outlined"
                                                    value={p?.mobileNumber || ''}
                                                    onChange={(e) => updateAuthorizedPickupItem(idx, { mobileNumber: e.target.value })}
                                                />

                                                <Box style={{ flex: '1 1 100%', width: '100%' }}>
                                                    <Box style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => handleAuthorizedPickupFileChange(idx, e)}
                                                        />
                                                        <Button
                                                            variant="contained"
                                                            style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                                            onClick={(e) => handleAuthorizedPickupPhotoUpload(idx, e)}
                                                        >
                                                            Upload Photo
                                                        </Button>
                                                    </Box>
                                                    {p?.photoURL ? (
                                                        <Box mt={1} style={{ position: 'relative', display: 'inline-block' }}>
                                                            <img
                                                                src={p.photoURL}
                                                                alt={`Authorized pickup ${idx + 1}`}
                                                                style={{
                                                                    width: 100,
                                                                    height: 100,
                                                                    objectFit: 'cover',
                                                                    borderRadius: 8,
                                                                    border: '1px solid #e2e8f0',
                                                                    display: 'block',
                                                                }}
                                                            />
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => updateAuthorizedPickupItem(idx, { photoURL: '' })}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 4,
                                                                    right: 4,
                                                                    backgroundColor: 'rgba(255,255,255,0.95)',
                                                                    padding: 4,
                                                                }}
                                                                aria-label="Remove pickup photo"
                                                            >
                                                                <CloseIcon fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    ) : null}
                                                </Box>

                                                <Button
                                                    variant="contained"
                                                    style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', minWidth: 36 }}
                                                    onClick={addAuthorizedPickupItem}
                                                >
                                                    +
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    style={{ backgroundColor: '#6c757d', color: 'white', minWidth: 36 }}
                                                    onClick={() => removeAuthorizedPickupItem(idx)}
                                                    disabled={authorizedPickupItems.length === 1}
                                                >
                                                    -
                                                </Button>
                                            </Box>
                                        ))}
                                    </Box>
                                </Grid>
                            ) : null}

                            {step === 2 && !isParentFillMode ? (<Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >
                                    Special Needs (Optional):
                                </span>
                            </Grid>) : null}
                            {step === 2 && !isParentFillMode ? (<Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="specialNeeds"
                                    name="specialNeeds"
                                    label="Special Needs"
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    minRows={3}
                                    value={formik.values.specialNeeds}
                                    onChange={formik.handleChange}
                                    error={formik.touched.specialNeeds && Boolean(formik.errors.specialNeeds)}
                                    helperText={formik.touched.specialNeeds && formik.errors.specialNeeds}
                                />
                            </Grid>) : null}
                            {step === 2 && !isParentFillMode && !hideMaskedAadhaarCard ? (<Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >upload Student Masked Adhar Card:</span>
                            </Grid>) : null}
                            {step === 2 && !isParentFillMode && !hideMaskedAadhaarCard ? (<Grid item xs={12}>
                                <input
                                    id="student-aadhar-upload"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                                <Button
                                    style={{
                                        backgroundColor: 'rgb(15 59 98)',
                                        color: 'white',
                                        border: 'none',
                                        marginLeft: 8,
                                    }}
                                    onClick={handleUpload}
                                >
                                    Upload
                                </Button>
                                {message ? (
                                    <Typography variant="caption" color="error" style={{ display: 'block', marginTop: 6 }}>
                                        {message}
                                    </Typography>
                                ) : null}
                                {getImageListArray(imageslist).length > 0 ? (
                                    <Box mt={2}>
                                        <Typography variant="body2" style={{ color: '#0f3b62ad', fontWeight: 700, marginBottom: 8 }}>
                                            Uploaded images ({getImageListArray(imageslist).length})
                                        </Typography>
                                        <Box display="flex" flexWrap="wrap" style={{ gap: 12 }}>
                                            {getImageListArray(imageslist).map((url, index) => (
                                                <Box key={`aadhar-${index}-${url}`} style={{ position: 'relative' }}>
                                                    <img
                                                        src={url}
                                                        alt={`Aadhar ${index + 1}`}
                                                        style={{
                                                            width: 100,
                                                            height: 100,
                                                            objectFit: 'cover',
                                                            borderRadius: 8,
                                                            border: '1px solid #e2e8f0',
                                                            display: 'block',
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removeGalleryImage(index)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            backgroundColor: 'rgba(255,255,255,0.95)',
                                                            padding: 4,
                                                        }}
                                                        aria-label="Remove image"
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                ) : null}
                            </Grid>) : null}

                            {step === 2 && !isParentFillMode ? (<Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >
                                    upload Birth Certificate (Optional):
                                </span>
                            </Grid>) : null}
                            {step === 2 && !isParentFillMode ? (<Grid item xs={12} sm={12} md={6}>
                                <input
                                    type="file"
                                    accept="image/*,application/pdf"
                                    onChange={handleBirthCertificateFileChange}
                                />
                                <Button
                                    style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', border: 'none' }}
                                    onClick={handleBirthCertificateUpload}
                                >
                                    Upload
                                </Button>
                                {birthCertificateMessage ? (
                                    <Typography variant="caption" color="error" style={{ display: 'block', marginTop: 6 }}>
                                        {birthCertificateMessage}
                                    </Typography>
                                ) : null}
                                {birthCertificateUrl ? (
                                    <Box mt={2}>
                                        <Typography variant="body2" style={{ color: '#0f3b62ad', fontWeight: 700, marginBottom: 8 }}>
                                            Uploaded file
                                        </Typography>
                                        {/\.(png|jpe?g|gif|webp)(\?|$)/i.test(birthCertificateUrl) ? (
                                            <Box style={{ position: 'relative', display: 'inline-block' }}>
                                                <img
                                                    src={birthCertificateUrl}
                                                    alt="Birth certificate"
                                                    style={{
                                                        width: 120,
                                                        height: 120,
                                                        objectFit: 'cover',
                                                        borderRadius: 8,
                                                        border: '1px solid #e2e8f0',
                                                    }}
                                                />
                                            </Box>
                                        ) : (
                                            <a href={birthCertificateUrl} target="_blank" rel="noreferrer">
                                                View birth certificate
                                            </a>
                                        )}
                                    </Box>
                                ) : null}
                            </Grid>) : null}

                            {!isParentFillMode && !hideAadhaarNumber ? (
                            <Grid item xs={12} sm={12} md={6}>

                                <TextField
                                    fullWidth

                                    margin="dense"
                                    id="adharNo"
                                    name="adharNo"
                                    label="Aadhaar number"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.adharNo}
                                    onChange={formik.handleChange}
                                    error={formik.touched.adharNo && Boolean(formik.errors.adharNo)}
                                    helperText={formik.touched.adharNo && formik.errors.adharNo}
                                />
                            </Grid>
                            ) : null}

                            {!isParentFillMode ? (
                            <>
                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad' }} >Address:</span>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="address"
                                    name="address"
                                    placeholder="Door/Flat/domicile number "
                                    label="Address "
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    error={formik.touched.address && Boolean(formik.errors.address)}
                                    helperText={formik.touched.address && formik.errors.address}
                                />
                            </Grid>
                            {useZipCodeLabel ? (
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="zipCode"
                                    name="zipCode"
                                    label="ZIP Code"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.zipCode}
                                    onChange={formik.handleChange}
                                    error={formik.touched.zipCode && Boolean(formik.errors.zipCode)}
                                    helperText={formik.touched.zipCode && formik.errors.zipCode}
                                />
                            </Grid>
                            ) : null}
                            </>
                            ) : null}

                            {step === 2 && !isParentFillMode ? (<Grid item xs={12} sm={12} md={6}>
                                <FormControl component="fieldset" style={{ marginTop: 8 }}>
                                    <FormLabel component="legend">Allergies?</FormLabel>
                                    <RadioGroup
                                        row
                                        name="hasAllergies"
                                        value={hasAllergies}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setHasAllergies(val);
                                            if (val === 'no') {
                                                setAllergyItems(['']);
                                            }
                                        }}
                                    >
                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="no" control={<Radio />} label="No" />
                                    </RadioGroup>

                                    {hasAllergies === 'yes' ? (
                                        <Box style={{ marginTop: 8 }}>
                                            {allergyItems.map((item, idx) => (
                                                <Box key={idx} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
                                                    <TextField
                                                        fullWidth
                                                        margin="dense"
                                                        label={`Allergy ${idx + 1}`}
                                                        type="text"
                                                        variant="outlined"
                                                        value={item}
                                                        onChange={(e) => updateAllergyItem(idx, e.target.value)}
                                                    />
                                                    <Button
                                                        variant="contained"
                                                        style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', minWidth: 36 }}
                                                        onClick={addAllergyItem}
                                                    >
                                                        +
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        style={{ backgroundColor: '#6c757d', color: 'white', minWidth: 36 }}
                                                        onClick={() => removeAllergyItem(idx)}
                                                        disabled={allergyItems.length === 1}
                                                    >
                                                        -
                                                    </Button>
                                                </Box>
                                            ))}
                                        </Box>
                                    ) : null}
                                </FormControl>
                            </Grid>) : null}
                        </Grid>

                        <div style={{ textAlign: 'right', margin: '40px 20px 20px 20px' }}>
                            {step === 2 ? (
                                <Button
                                    style={{ backgroundColor: '#6c757d', color: 'white', marginRight: '10px' }}
                                    onClick={() => setStep(1)}
                                    variant="contained"
                                >
                                    Back
                                </Button>
                            ) : null}
                            <Button
                                style={{ backgroundColor: '#6c757d', color: 'white', marginRight: '10px' }}
                                onClick={() => setPreviewOpen(true)}
                                variant="contained"
                            >
                                Preview
                            </Button>
                            {step === 1 ? (
                                <Button
                                    style={{ backgroundColor: ' rgb(15 59 98)', color: 'white' }}
                                    onClick={goToParentStep}
                                    variant="contained"
                                >
                                    Next → Parent Details
                                </Button>
                            ) : (
                                <Button
                                    style={{ backgroundColor: ' rgb(15 59 98)', color: 'white' }}
                                    onClick={formik.handleSubmit}
                                    type="submit"
                                    variant="contained"
                                >
                                    Save
                                </Button>
                            )}
                        </div>

                    </div>
                </Box>
            </Card>

            {/* Preview Dialog */}
            <Dialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '20px'
                    }
                }}
            >
                <DialogTitle style={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold', color: '#0f3b62' }}>
                    Student Registration Preview
                </DialogTitle>
                <DialogContent>
                    <Box style={{ padding: '20px' }}>
                        {/* Student Photo */}
                        {!isParentFillMode && imageslist1 ? (
                            <Box style={{ textAlign: 'center', marginBottom: '20px' }}>
                                <Typography variant="h6" style={{ marginBottom: '10px', color: '#0f3b62' }}>
                                    Student Photo
                                </Typography>
                                <img
                                    src={imageslist1}
                                    alt="Student profile"
                                    style={{
                                        width: 120,
                                        height: 120,
                                        objectFit: 'cover',
                                        borderRadius: 8,
                                        border: '2px solid #e0e0e0',
                                    }}
                                />
                            </Box>
                        ) : null}

                        <Divider style={{ margin: '20px 0' }} />

                        {/* Basic Information */}
                        <Typography variant="h6" style={{ marginBottom: '15px', color: '#0f3b62', fontWeight: 'bold' }}>
                            Basic Information
                        </Typography>
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>{admissionFieldLabel}:</Typography>
                                <Typography variant="body1">{formik.values.admissionNumber || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>First Name:</Typography>
                                <Typography variant="body1">{formik.values.firstName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Middle Name:</Typography>
                                <Typography variant="body1">{formik.values.middleName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Last Name:</Typography>
                                <Typography variant="body1">{formik.values.lastName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Date of Birth:</Typography>
                                <Typography variant="body1">{formik.values.dob ? formatDate(formik.values.dob) : 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Gender:</Typography>
                                <Typography variant="body1">{formik.values.gender || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Status:</Typography>
                                <Typography variant="body1">
                                    {formik.values.status === false || formik.values.status === 'false'
                                        ? 'Inactive'
                                        : 'Active'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Class:</Typography>
                                <Typography variant="body1">{getPreviewClassName()}</Typography>
                            </Grid>
                        </Grid>

                        <Divider style={{ margin: '20px 0' }} />

                        {/* Family Details */}
                        <Typography variant="h6" style={{ marginBottom: '15px', color: '#0f3b62', fontWeight: 'bold' }}>
                            Family Details
                        </Typography>
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Mother's Name:</Typography>
                                <Typography variant="body1">{formik.values.motherName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Father's Name:</Typography>
                                <Typography variant="body1">{formik.values.fatherName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Parent-1 Gmail / Email:</Typography>
                                <Typography variant="body1">{formik.values.motherEmail || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Parent-2 Gmail / Email:</Typography>
                                <Typography variant="body1">{formik.values.fatherEmail || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Parent Mobile Number:</Typography>
                                <Typography variant="body1">{formik.values.mobileNumber || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Authorized Pickup(s):</Typography>
                                {isParentFillMode ? (
                                    <Typography variant="body1">Parent will complete in parent app</Typography>
                                ) : (
                                <>
                                {(authorizedPickupItems || [])
                                    .filter((p) => (p?.name || '').trim() || (p?.mobileNumber || '').trim() || (p?.photoURL || '').trim())
                                    .slice(0, 10)
                                    .map((p, idx) => (
                                        <Box key={idx} style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 6 }}>
                                            {p?.photoURL ? (
                                                <img
                                                    src={p.photoURL}
                                                    alt={`Pickup ${idx + 1}`}
                                                    style={{ width: 44, height: 44, objectFit: 'cover', borderRadius: 6 }}
                                                />
                                            ) : null}
                                            <Typography variant="body1">
                                                {(p?.name || '—')}{p?.mobileNumber ? ` — ${p.mobileNumber}` : ''}
                                            </Typography>
                                        </Box>
                                    ))}
                                {(authorizedPickupItems || []).filter((p) => (p?.name || '').trim() || (p?.mobileNumber || '').trim() || (p?.photoURL || '').trim()).length === 0 ? (
                                    <Typography variant="body1">Not provided</Typography>
                                ) : null}
                                </>
                                )}
                            </Grid>
                        </Grid>

                        <Divider style={{ margin: '20px 0' }} />

                        {isParentFillMode ? (
                            <Box style={{ marginBottom: 20, padding: 12, borderRadius: 8, backgroundColor: '#eef4ff', border: '1px solid #d6e4ff' }}>
                                <Typography variant="body2" style={{ color: '#0f2d4d', fontWeight: 600 }}>
                                    Parent will complete in parent app:
                                </Typography>
                                <Typography variant="body2" style={{ color: '#46566b', marginTop: 6 }}>
                                    Profile photo, authorized pickup, {hideAadhaarNumber ? "ZIP code, " : "Aadhaar number, "}address, special needs, {hideMaskedAadhaarCard ? "" : "masked Aadhaar card, "}birth certificate, and allergies.{hideAadhaarNumber ? " Social Security Number is optional for the parent." : ""}
                                </Typography>
                            </Box>
                        ) : (
                        <>
                        <Typography variant="h6" style={{ marginBottom: '15px', color: '#0f3b62', fontWeight: 'bold' }}>
                            Additional Information
                        </Typography>
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={12}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Address:</Typography>
                                <Typography variant="body1">{formik.values.address || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Lane:</Typography>
                                <Typography variant="body1">{formik.values.lane || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>{hideAadhaarNumber ? 'ZIP Code:' : 'Aadhar Number:'}</Typography>
                                <Typography variant="body1">{hideAadhaarNumber ? (formik.values.zipCode || 'Not provided') : (formik.values.adharNo || 'Not provided')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>{enrollmentDateLabel}:</Typography>
                                <Typography variant="body1">{formik.values.doa || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Allergies:</Typography>
                                <Typography variant="body1">
                                    {hasAllergies === 'yes'
                                        ? allergyItems.map((s) => String(s).trim()).filter(Boolean).join(', ') || 'Yes'
                                        : 'No'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Special Needs:</Typography>
                                <Typography variant="body1">{formik.values.specialNeeds || 'None'}</Typography>
                            </Grid>
                        </Grid>
                        </>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions style={{ padding: '20px', justifyContent: 'center' }}>
                    <Button 
                        onClick={() => setPreviewOpen(false)}
                        style={{ backgroundColor: '#6c757d', color: 'white', marginRight: '10px' }}
                        variant="contained"
                    >
                        Close
                    </Button>
                    <Button 
                        onClick={() => {
                            setPreviewOpen(false);
                            formik.handleSubmit();
                        }}
                        style={{ backgroundColor: '#0f3b62', color: 'white' }}
                        variant="contained"
                    >
                        Submit Registration
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


